import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete an if node and all connected edgee
 * @param context
 * @param reactFlowInstance
 */
export function processIfNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.editableIfNodeConfiguration.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.editableIfNodeConfiguration.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);

}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.editableIfNodeConfiguration;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}


export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        data_store: {
            'type': 'string',
            title: 'Data Input',
            'description': 'Data to be evaluated',
            default: 'default'
        },
        input_key: {
            'title': 'Data Value Key',
            type: 'string',
            description: 'Value for data model attributes, enter as value_one/value_two',
        },
        "if_type": {
            title: 'Action Type',
            enum: [
                "Agent",
                "Conditional"
            ],
            default: "Conditional",
        },

    },
    allOf: [
        {
            if: {
                properties: {
                    "if_type": {
                        const: "Agent"
                    }
                }
            },
            then: {
                properties: {
                    system_prompt: {
                        title: 'Agent\'s - System Prompt',
                        type: 'string',
                        description: 'Describe what the agent does, give it some context. The agent will only return a true or false value',
                    },
                    action_prompt: {
                        title: 'Agent action prompt',
                        description: 'Let the Agent know which values you want to compare. The Agent will only return a true or false',
                        type: 'string',
                    },
                    llm_temperature: {
                        type: "number",
                        title: "LLM Temperature",
                        default: 0.7,
                        description: "The temperature of the LLM, higher values will result in more creative responses."
                    },
                    llm: {
                        title: 'LLM',
                        type: 'string',
                    },
                }
            }
        },
        {
            if: {
                properties: {
                    "if_type": {
                        const: "Conditional"
                    }
                }
            },
            then: {
                properties: {
                    if_condition: {
                        title: 'If Condition Type',
                        type: 'string',
                        enum: [
                            'AND',
                            'OR'
                        ],
                        default: 'AND'
                    },
                    evaluation_options: {
                        title: 'Evaluation Options',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                evaluation: {
                                    title: 'Conditional',
                                    type: 'string',
                                    enum: [
                                        'Equal To',
                                        'Not Equal To',
                                        'Greater Than',
                                        'Less Than',
                                        'Length Greater Than',
                                        'Length Less Than',
                                        'Length Equal To',
                                        'Is String',
                                        'Is Not String',
                                        'Is Array',
                                        'Is Not Array',
                                        'Is Data Model',
                                        'Is Not Data Model',
                                        'Is Number',
                                        'Is Not Number',
                                        'Is True',
                                        'Is False',
                                        'Parsable JSON'
                                    ],
                                    default: 'Equal To',
                                    description: 'The conditional type to evaluate the data input against. Length is for arrays or text'
                                },
                                evaluation_value: {
                                    title: 'Condition Value',
                                    type: 'string',
                                    description: 'The value to compare the data input against'
                                }
                            }
                        }
                    },
                }
            }
        },
    ]
}

export const nodeDescription: string = "This node is a routing node.\n" +
    "If the condition is met or the AI has made a decision then either the True or False paths will execute.\n";